<template>
  <div class="slide">
    <ul class="slide-wrapper">
      <li @click="changeBodyContent(0)">
        <div class="slide-item" :style="(activeIndex == 0)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.homeSrc" />
          <span class="item-right">主页</span>
        </div>
      </li>
      <li @click="changeBodyContent(2)">
        <div class="slide-item" :style="(activeIndex == 2)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.memberSrc" />
          <span class="item-right">肯德基会员</span>
        </div>
      </li>
      <li @click="changeBodyContent(3)">
        <div class="slide-item" :style="(activeIndex == 3)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.promoteSrc" />
          <span class="item-right">肯德基订单</span>
        </div>
      </li>
      <li @click="changeBodyContent(10)">
        <div class="slide-item" :style="(activeIndex == 10)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.memberSortSrc" />
          <span class="item-right">会员排名</span>
        </div>
      </li>
      <li @click="changeBodyContent(4)">
        <div class="slide-item" :style="(activeIndex == 4)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.wechatSrc" />
          <span class="item-right">公众号授权</span>
        </div>
      </li>
      <li @click="changeBodyContent(6)">
        <div class="slide-item" :style="(activeIndex == 6)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.withdrawSrc" />
          <span class="item-right">提现记录</span>
        </div>
      </li>
      <li @click="changeBodyContent(1)">
        <div class="slide-item" :style="(activeIndex == 1)?activeStyleObj:''">
          <img class="item-left" :src="slideImgObj.inviteSrc" />
          <span class="item-right">网站推广</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { Modal } from 'view-design'
  import slideActiveImg from '@/assets/img/kfc/slide_active.png'
  import kfcBtnHomeN from '@/assets/img/kfc/leftbar_btn_homepage_n.png'
  import kfcBtnHomeS from '@/assets/img/kfc/leftbar_btn_homepage_s.png'
  import kfcBtnInviteN from '@/assets/img/kfc/leftbar_btn_tuiguang_n.png'
  import kfcBtnInviteS from '@/assets/img/kfc/leftbar_btn_tuiguang_s.png'
  import kfcBtnMemberN from '@/assets/img/kfc/leftbar_btn_kfc_n.png'
  import kfcBtnMemberS from '@/assets/img/kfc/leftbar_btn_kfc_s.png'
  import kfcBtnPromoteN from '@/assets/img/kfc/leftbar_btn_kfcorder_n.png'
  import kfcBtnPromoteS from '@/assets/img/kfc/leftbar_btn_kfcorder_s.png'
  import kfcBtnMemberSortN from '@/assets/img/kfc/leftbar_btn_member_sort_n.png'
  import kfcBtnMemberSortS from '@/assets/img/kfc/leftbar_btn_member_sort_s.png'
  import kfcBtnWechatN from '@/assets/img/kfc/leftbar_btn_wechat_n.png'
  import kfcBtnWechatS from '@/assets/img/kfc/leftbar_btn_wechat_s.png'
  import kfcBtnActivationN from '@/assets/img/kfc/leftbar_btn_activation_n.png'
  import kfcBtnActivationS from '@/assets/img/kfc/leftbar_btn_activation_s.png'
  import kfcBtnWithdrawN from '@/assets/img/kfc/leftbar_btn_withdrawal_n.png'
  import kfcBtnWithdrawS from '@/assets/img/kfc/leftbar_btn_withdrawal_s.png'
  import kfcBtnSetN from '@/assets/img/kfc/leftbar_btn_set_n.png'
  import kfcBtnSetS from '@/assets/img/kfc/leftbar_btn_set_s.png'
  export default {
    name: "SildeNav",
    components: {},
    data: function() {
      return {
        activeStyleObj: {
          backgroundImage: 'url(' + slideActiveImg + ')',
          backgroundSize: '100% 100%',
          color: '#fff'
        },
        slideImgObj: {
          homeSrc: kfcBtnHomeS,
          inviteSrc: kfcBtnInviteN,
          memberSrc: kfcBtnMemberN,
          promoteSrc: kfcBtnPromoteN,
          memberSortSrc: kfcBtnMemberSortN,
          wechatSrc: kfcBtnWechatN,
          activationSrc: kfcBtnActivationN,
          withdrawSrc: kfcBtnWithdrawN,
          setSrc: kfcBtnSetN,
        },
      }
    },
    watch: {
      activeIndex: function() {
        this.initImgSrc()
      }
    },
    computed: {
      activeIndex: function(){
        return this.$store.getters.kfcAccountActiveIndex
      }
    },
    mounted: function() {
      var path = this.$route.path
      var activeIndex
      switch (path) {
        case '/pc/kfc/statistics':
          activeIndex = 0
          break;
        case '/pc/kfc/invite':
          activeIndex = 1
          break;
        case '/pc/kfc/member':
          activeIndex = 2
          break;
        case '/pc/kfc/order':
          activeIndex = 3
          break;
        case '/pc/kfc/sort':
          activeIndex = 10
          break;
        case '/pc/kfc/authorization':
          activeIndex = 4
          break;
        case '/pc/kfc/withdraw':
          activeIndex = 6
          break;
        default:
          activeIndex = 0
      }
      this.$store.dispatch('nav/changeKfcAccountActiveIndex', activeIndex)
      if(this.$pc && this.$store.getters.personalActiveIndex === 'undefined') {
        this.changeBodyContent(activeIndex)
      }
    },
    methods: {
      initImgSrc: function() {
        this.slideImgObj = {
          homeSrc: (this.activeIndex == 0) ? kfcBtnHomeS : kfcBtnHomeN,
          inviteSrc: (this.activeIndex == 1) ? kfcBtnInviteS : kfcBtnInviteN,
          memberSrc: (this.activeIndex == 2) ? kfcBtnMemberS : kfcBtnMemberN,
          promoteSrc: (this.activeIndex == 3) ? kfcBtnPromoteS : kfcBtnPromoteN,
          memberSortSrc: (this.activeIndex == 10) ? kfcBtnMemberSortS : kfcBtnMemberSortN,
          wechatSrc: (this.activeIndex == 4) ? kfcBtnWechatS : kfcBtnWechatN,
          withdrawSrc: (this.activeIndex == 6) ? kfcBtnWithdrawS : kfcBtnWithdrawN,
        }
      },
      changeBodyContent: function(activeIndex) {
        var url = ''
        switch (activeIndex) {
          case 1:
            url = '/pc/kfc/invite'
            break;
          case 2:
            url = '/pc/kfc/member'
            break;
          case 3:
            url = '/pc/kfc/order'
            break;
          case 10:
            url = '/pc/kfc/sort'
            break;
          case 4:
            url = '/pc/kfc/authorization'
            break;
          case 6:
            url = '/pc/kfc/withdraw'
            break;
          default:
            url = '/pc/kfc/statistics'
        }
        this.$store.dispatch('nav/changeKfcAccountActiveIndex', activeIndex)
        this.$router.push(url).catch(err => {
          err
        })
      }
    }
  }
</script>

<style scoped>
  .slide {
    width: 4.4rem;
    background: #fdfdfd;
  }

  .slide-wrapper {
    list-style: none;
  }

  .slide-wrapper li {
    width: 100%;
    height: 1rem;
    text-align: center;
  }

  .slide-wrapper li .slide-item {
    display: flex;
    padding: 0 0.5rem;
    height: 100%;
    cursor: pointer;
    align-items: center;
    color: #666666;
    font-size: 14px;
  }

  .slide-wrapper li .slide-item .item-left {
    width: 0.4rem;
    float: left;
    margin-right: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/kfc/SildeNav.vue